module.exports = __webpack_public_path__ + "static/img/potenciometro_50k-1.aaad754.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/potenciometro_50k-1.svg
// module id = YemF
// module chunks = 0